import { useMemo } from "react";

import { EyeTracking as EyeTrackingComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

import { isComponentPartOfSharedRow } from "../../utils/utils";

interface EyeTrackingProps {
    subDimensionsData?: any;
    isInsideModal?: boolean;
}

const EyeTracking = ({ subDimensionsData, isInsideModal }: EyeTrackingProps) => {
    const {
        combinedCustomChartsData,
        isErrorCombinedCustomCharts,
        isFetchingCombinedCustomCharts,
        gridLayoutData,
    } = useSessionDetailsContext();

    const isPartOfSharedRow = useMemo(() => {
        return isComponentPartOfSharedRow(gridLayoutData, "EyeTracking");
    }, [gridLayoutData]);

    const data = isInsideModal ? subDimensionsData : combinedCustomChartsData;

    const isEmptyState = !isErrorCombinedCustomCharts && (!data || data?.length === 0);

    if (isFetchingCombinedCustomCharts) {
        return <ContentLoader height={isPartOfSharedRow ? "21.1875rem" : "23.5rem"} />;
    }

    if (isEmptyState) {
        return (
            <ComponentWrapper>
                <EmptyState
                    emptyStateType={EmptyStateType.Charts}
                    title="session-details:eye-tracking:empty-state:title"
                    minHeight={isPartOfSharedRow ? "18.1875rem" : "20.5rem"}
                />
            </ComponentWrapper>
        );
    }

    if (isErrorCombinedCustomCharts && !isFetchingCombinedCustomCharts) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                    minHeight={isPartOfSharedRow ? "18.1875rem" : "20.5rem"}
                />
            </ComponentWrapper>
        );
    }

    return <EyeTrackingComponent data={data} isPartOfSharedRow={isPartOfSharedRow} />;
};

export default EyeTracking;
